import { workflowAxiosGet } from "../utils/workflowAuthHeaders";

const fetchContatos = async ({
  empresa = "01",
  filial = "01",
  page = 1,
  pageSize = 10000,
  cliente,
  loja = "01",
  token,
  username,
  password
}) => {
  const baseUrl = "https://workflow.grupocenze.com.br:38137/rest/";

  try {
    const response = await workflowAxiosGet(
      `${baseUrl}api/v1/contatos`,
      {
        params: {
          empresa,
          filial,
          Page: page,
          PageSize: pageSize,
          cliente,
          loja
        }
      },
      { token, username, password }
    );
    return response.data;
  } catch (error) {
    console.error("Erro ao buscar contatos:", error);
    throw error;
  }
};

export default fetchContatos;
